import { ConfiguredServiceFormPage } from "./ConfiguredServiceFormPage";
import { signatureSongFormConfig } from "./configuredServiceForms";

export function SignatureSongFormPage() {
  return <ConfiguredServiceFormPage config={signatureSongFormConfig} />;
}
